// extracted by mini-css-extract-plugin
module.exports = {"container":"LockedReason_container__286n2","message":"LockedReason_message___fatI","text":"LockedReason_text__3Xc7w"};